/* import __COLOCATED_TEMPLATE__ from './canvas-kit-builder.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();